import Amex from 'shared/assets/brands/amex.svg';
import Klarna from 'shared/assets/brands/klarna.svg';
import Mastercard from 'shared/assets/brands/mastercard.svg';
import Swish from 'shared/assets/brands/swish.svg';
import Visa from 'shared/assets/brands/visa.svg';
import { SvgImage } from 'shared/components/svg-image';
import { View } from 'react-native';

const PaymentBrands = ({ className, large }: { className?: string; large?: boolean }) => {
  return (
    <View className={`flex-row items-center ${className} ${large ? 'gap-3' : 'gap-1'}`}>
      <SvgImage
        src={Swish}
        alt={'Swish'}
        containerClassName={`aspect-[4.6/2] ${large ? 'h-10' : 'h-6'}`}
      />
      <SvgImage
        src={Klarna}
        alt={'Klarna'}
        containerClassName={`aspect-[8/4.4] ${large ? 'h-10' : 'h-6'}`}
      />
      <SvgImage
        src={Visa}
        alt={'Visa'}
        containerClassName={`aspect-[2.4/1.6] ${large ? 'h-10' : 'h-6'}`}
      />
      <SvgImage
        src={Mastercard}
        alt={'Mastercard'}
        containerClassName={`aspect-[2.4/1.6] ${large ? 'h-10' : 'h-6'}`}
      />
      <SvgImage
        src={Amex}
        alt={'American Express'}
        containerClassName={`aspect-[2.4/1.6] ${large ? 'h-10' : 'h-6'}`}
      />
    </View>
  );
};

export { PaymentBrands };
